import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=134d4191&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('134d4191')) {
      api.createRecord('134d4191', component.options)
    } else {
      api.reload('134d4191', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=134d4191&", function () {
      api.rerender('134d4191', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/views/ForgotPassword.vue"
export default component.exports